import React from 'react';
import { CDN_URLS } from '../config/cdn';
import SpriteAnimatedLogo from '../ui/SpriteAnimatedLogo.js';
import { DEFAULT_ANIM_FRAME_RATE } from '../config/const.js';
import { SPRITES } from '../ui/SpriteAnimatedLogo.js';

const Features = () => {
  return (
    <section className="features">
      <div className="section-header">
        <h2>File System Agentic Memory: Beyond Traditional Memory Systems</h2>
        <p>Revolutionary agentic memory architecture that transforms how AI agents remember, learn, and evolve. Our intelligent file system automatically organizes, connects, and evolves with your memories through autonomous agent behavior.</p>
      </div>
      <div className="features-notion-grid">
        <div style={{ position: 'relative' }} className="features-left-column">
          <div className="features-left-column">
            <div className="feature-card feature-organize">
              <div className="feature-header">
                <h4>📋 Organize</h4>
                <h3>Autonomous Memory Management</h3>
              </div>
            </div>
            <div className="feature-image">
              <img src={CDN_URLS.feature1} alt="Organize - Autonomous Memory Management" />
            </div>
          </div>
          <div className="feature-anim1">
            <SpriteAnimatedLogo
              width={48}
              height={48}
              frameRate={DEFAULT_ANIM_FRAME_RATE}
              autoPlay={true}
              filename={SPRITES.ANIM_HEAD_AND_HANDS} />
          </div>
        </div>
        <div className="features-right-column">
          <div className="feature-card feature-link">
            <div className="feature-header">
              <h4>🔗 Link</h4>
              <h3>Interconnected <br /> Knowledge Graph</h3>
            </div>
            <div className="feature-image">
              <img src={CDN_URLS.feature2} alt="Link - Interconnected Knowledge Graph" />
            </div>
          </div>
          <div className="feature-card feature-evolve">
            <div className="feature-header">
              <h4>🚀 Evolve</h4>
              <h3>Agentic Memory <br /> Evolution</h3>
            </div>
            <div className="feature-image">
              <img src={CDN_URLS.feature3} alt="Evolve - Continuous Self-Improvement" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;